module.exports = __webpack_public_path__ + "img/mobile-title.b4c866bf.webp";